import APIService from "@/services/api-factory";

export default class PagesService {
    static setStruct = guid => APIService.post(`/page/${guid}/struct`);
    static setTranslation = (guid, language) => APIService.post(`/page/${guid}/${language}/translate`);
}
